import "./propcreate.css"
function PropCreate(){
    return(
        <>
        <div className="propcreate">
           <div className="start">
                <h4>Propsal Creates </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
  <div className="formsubject">

    {/* Subject */}
    <input 
      type="text" 
      placeholder="Enter subject..." 
      name="subject" 
      id="subject"
      className="form-control mb-3"
    />

    {/* Contact Type */}
    <select 
      name="contactType" 
      id="contactType"
      className="form-select mb-3"
    >
      <option value="">Select Type</option>
      <option value="lead">Lead</option>
      <option value="customer">Customer</option>
      <option value="partner">Partner</option>
    </select>

    {/* Assigned To */}
    <select 
      name="assignedTo" 
      id="assignedTo"
      className="form-select mb-3"
    >
      <option value="">Assign To</option>
      <option value="omar_rehan">Omar Rehan (Front-End Developer)</option>
      <option value="sara_mohamed">Sara Mohamed (UI/UX Designer)</option>
      <option value="ahmed_khaled">Ahmed Khaled (Back-End Developer)</option>
      <option value="laila_mostafa">Laila Mostafa (Project Manager)</option>
    </select>

    {/* Visibility */}
    <select 
      name="visibility" 
      id="visibility"
      className="form-select"
    >
      <option value="">Select Visibility</option>
      <option value="public">Public</option>
      <option value="private">Private</option>
      <option value="personal">Personal</option>
      <option value="custom">Custom</option>
    </select>
 {/* Discount */}
    <select 
      name="Discount" 
      id="Discount"
      className="form-select"
    >
      <option value="">Select Discount</option>
      <option value="public">Before Tax</option>
      <option value="private">After Tax</option>
 
    </select>
  </div>
</div>
<div className="col-md-6">
     <div className="formsubject">
<div className="col-md-12">
    <div className="fromsubject">
        
    </div>
     {/* Email */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Email</label>
    <input 
      type="email" 
      className="form-control" 
      name="email"
      placeholder="example@email.com"
    />
  </div>

  {/* Phone */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Phone</label>
    <input 
      type="tel" 
      className="form-control" 
      name="phone"
      placeholder="+20 10 1234 5678"
    />
  </div>

  {/* Address */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Address</label>
    <input 
      type="text" 
      className="form-control" 
      name="address"
      placeholder="Enter address"
    />
  </div>

  {/* Country */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Country</label>
    <select className="form-select" name="country">
      <option value="">Select Country</option>
      <option value="egypt">Egypt</option>
      <option value="uae">UAE</option>
      <option value="saudi">Saudi Arabia</option>
      <option value="usa">USA</option>
    </select>
  </div>

  {/* State */}
  <div className="col-md-12 mb-3">
    <label className="form-label">State</label>
    <input 
      type="text" 
      className="form-control" 
      name="state"
      placeholder="Enter state"
    />
  </div>

  {/* City */}
  <div className="col-md-12 mb-3">
    <label className="form-label">City</label>
    <input 
      type="text" 
      className="form-control" 
      name="city"
      placeholder="Enter city"
    />
  </div>

  {/* Timezone */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Timezone</label>
    <select className="form-select" name="timezone">
      <option value="">Select Timezone</option>
      <option value="gmt+2">GMT +2 (Cairo)</option>
      <option value="gmt+3">GMT +3 (Riyadh)</option>
      <option value="gmt-5">GMT -5 (New York)</option>
    </select>
  </div>

  {/* Status */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Status</label>
    <select className="form-select" name="status">
      <option value="">Select Status</option>
      <option value="active">Active</option>
      <option value="inactive">Inactive</option>
      <option value="pending">Pending</option>
    </select>
  </div>

  {/* Currency */}
  <div className="col-md-12 mb-3">
    <label className="form-label">Currency</label>
    <select className="form-select" name="currency">
      <option value="">Select Currency</option>
      <option value="egp">EGP</option>
      <option value="usd">USD</option>
      <option value="sar">SAR</option>
      <option value="aed">AED</option>
    </select>
  </div>

  {/* Allow Comments */}
  <div className="col-12 mb-3">
    <div className="form-check">
      <input 
        className="form-check-input" 
        type="checkbox" 
        name="allowComments" 
        id="allowComments"
      />
      <label className="form-check-label" htmlFor="allowComments">
        Allow Comments
      </label>
    </div>
  </div>


</div>
    
  </div>

</div>


   

 

            </div>

        </div>
        </>
    )
}
export default PropCreate